import CompanyViewHeader from 'components/company-view/company-view-header/company-view-header';
import './company-view-header.desktop.scss';

const CompanyViewHeaderDesktop = CompanyViewHeader;

export default CompanyViewHeaderDesktop;
